import React, { useEffect, useState, useMemo } from "react";
import { logEventos } from "../../../services/services";
import { getData } from "../../../services/library";
import moment from "moment";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Button, MenuItem, ListItemIcon, Typography, Container } from '@mui/material';
import Navbar from "../../Navbar";
import { AddBoxTwoTone, Autorenew } from "@mui/icons-material";
import Addprecio from "./Addprecio";
import DialogActualizar from "./DialogActualizar";

export default function TablaLista() {
    const [showTabla, setshowTabla] = useState(true);
    const [showAlta, setshowAlta] = useState(false);
    const [showActualizar, setshowActualizar] = useState(false);
    const [lista, setLista] = useState([]);
    const [rowData, setrowData] = useState();

    const obtenerLista = () =>{
        getData('/lista_precios/envasado', setLista);
    }

    useEffect(() => {
      obtenerLista()
    }, [showTabla]);


    const handleClickAlta = () => {
        setshowAlta(true);
        setshowTabla(false);
    };

    const handleActualizar = (rowData) => {
        setshowActualizar(true);
        setshowTabla(true);
        setrowData(rowData)
    };

    const columns = useMemo(
        () => [
            // { header: "ID lista", accessorKey: "id_lista", size: 100 },
            {
                header: " ",
                columns: [
                    // {
                    //     header: "Sucursal",
                    //     accessorKey: "sucursal",
                    //     size: 100,
                    // },

                    {
                        header: "Producto",
                        accessorKey: "nombre",
                        size: 150,
                    },
                ],
            },

            {
                header: "Precio",
                columns: [
                    {
                        header: "Sin IVA",
                        accessorFn:(precio) => (precio.precio_sin_iva).toFixed(4),
                        size: 70,
                    },
                    {
                        header: "Con IVA",
                        accessorFn:(precio) => (precio.precio_iva).toFixed(4),
                        size: 70,
                    },

                ],
            },
            {
                header: "Vigencia",
                columns: [
                    {
                        header: "Inicio",
                        // accessorKey: "vigencia",
                        accessorFn: (fecha) => moment(fecha.vigencia).format("DD-MM-YYYY"),
                        size: 70,
                    },
                    {
                        header: "Fin",
                        // accessorKey: "fin_vigencia",
                        accessorFn: (fecha) => fecha.fin_vigencia ? moment(fecha.fin_vigencia).format("DD-MM-YYYY") : "Sin registrar",
                        size: 70,
                    },
                ],
            },
        ],
        []
    );

    const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
        variant: "outlined",
        color: "success",
        size: "small",
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 1000 },
    };

    const tableHeadCellProps = {
        align: "left",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };

    const displayColumnDefOptions = {
        "mrt-row-actions": {
                         muiTableHeadCellProps: {
                             align: "left",
                         },
                         muiTableBodyCellProps: {
                             align: "left",
                         },
                     },
      };


useEffect(() => {
  logEventos("acceso al menú Lista Precios Envasado", "Envasado", "Lista Precios Envasado", localStorage.getItem("user"));
}, []);

    return (
        <div>
            <Navbar />
            <Container maxWidth="xl" sx={{ my: 1 }} disableGutters>
                {showTabla && <MaterialReactTable 
                 enableBottomToolbar={false}
                 localization={MRT_Localization_ES}
                 columns={columns}
                 enableRowActions={true}
                 enableRowVirtualization={true}
                 data={lista ?? [{}]}
                 layoutMode={"grid"}
                 enablePagination={false}
                 initialState={initialState}
                 enableColumnActions={false}
                 enableGlobalFilterModes={false}
                 enableHiding={false}
                 enableColumnFilters={false}
                 enableFullScreenToggle={false}
                 positionActionsColumn={"last"}
                 enableExpandAll={false}
                 enableToolbarInternalActions={true}
                 muiTableHeadCellProps={tableHeadCellProps}
                 muiSearchTextFieldProps={muiSearchTextFieldProps}
                 enableDensityToggle={false}
                 displayColumnDefOptions={displayColumnDefOptions}
                 enableColumnResizing={true}
                 muiTableBodyCellProps={({ row }) => ({
                     align: "left",
                     sx: {
                         backgroundColor: "#fff",
                         color: "black",
                         borderColor: "black",
                     },
                 })}
                 renderTopToolbarCustomActions={() => (
                     <>
                         <Button
                             variant="contained"
                             color="primary"
                             startIcon={<AddBoxTwoTone />}
                             onClick={handleClickAlta}
                         >
                             Nuevo Registro
                         </Button>
                         <Typography variant="poster" fontSize={26}>
                             Lista de Precios Envasado
                         </Typography>
                     </>
                 )}
                 renderRowActionMenuItems={({ closeMenu, row, index }) => [
                     <MenuItem
                         key={0}
                         sx={{ m: 0 }}
                         disabled={row.original.fin_vigencia}
                         onClick={() => {
                             handleActualizar(row.original)
                             closeMenu();
                         }}>
                         <ListItemIcon>
                             <Autorenew color="primary" />
                         </ListItemIcon>
                         Actualizar precio
                     </MenuItem>
         
                 ]}
                />}
                {showAlta && <Addprecio alta={setshowAlta} tabla={setshowTabla} />}
                {showActualizar && <DialogActualizar open={setshowActualizar} tabla={setshowTabla} datosExisten={rowData} actualizar={obtenerLista} />}
            </Container>
        </div>
    )

}